/**
 * Upcart: show "Total" instead of "Subtotal",
 * replace checkout tax notes with free shipping,
 * and translate leftover Spanish cart chrome.
 */
(function () {
  var FROM = /^\s*Subtotal\s*$/i;
  var TO = 'Total';

  function collectRoots(root, list) {
    if (!root || list.indexOf(root) !== -1) return list;
    list.push(root);
    try {
      var nodes = root.querySelectorAll ? root.querySelectorAll('*') : [];
      for (var i = 0; i < nodes.length; i++) {
        if (nodes[i].shadowRoot) collectRoots(nodes[i].shadowRoot, list);
      }
    } catch (e) {}
    return list;
  }

  function roots() {
    return collectRoots(document, []);
  }

  function lang() {
    return (document.documentElement.lang || '').toLowerCase();
  }

  function country() {
    return String(window.orCountry || '').toUpperCase();
  }

  function freeShippingMarket() {
    return country() === 'ES';
  }

  function freeShippingLabel() {
    var l = lang();
    if (!freeShippingMarket()) {
      if (l.indexOf('fr') === 0) return 'Livraison 4–8 jours';
      if (l.indexOf('de') === 0) return 'Versand 4–8 Werktage';
      if (l.indexOf('en') === 0) return 'Shipping 4–8 days';
      if (l.indexOf('pt') === 0) return 'Envio 4–8 dias';
      return 'Envío 4–8 días';
    }
    if (l.indexOf('fr') === 0) return 'Livraison offerte en Espagne';
    if (l.indexOf('de') === 0) return 'Kostenloser Versand nach Spanien';
    if (l.indexOf('en') === 0) return 'Free shipping in Spain';
    if (l.indexOf('pt') === 0) return 'Envio grátis para Espanha';
    return 'Envío gratis';
  }

  function checkoutLabel() {
    var l = lang();
    if (l.indexOf('fr') === 0) return 'ACHETER';
    if (l.indexOf('de') === 0) return 'KAUFEN';
    if (l.indexOf('en') === 0) return 'BUY';
    if (l.indexOf('pt') === 0) return 'COMPRAR';
    return 'COMPRAR';
  }

  function discountLabel() {
    var l = lang();
    if (l.indexOf('fr') === 0) return 'Vous avez un code promo ?';
    if (l.indexOf('de') === 0) return 'Hast du einen Rabattcode?';
    if (l.indexOf('en') === 0) return 'Have a discount code?';
    if (l.indexOf('pt') === 0) return 'Tem um código de desconto?';
    return '¿Tienes código de descuento?';
  }

  function relatedLabel() {
    var l = lang();
    if (l.indexOf('fr') === 0) return 'Vous aimerez aussi';
    if (l.indexOf('de') === 0) return 'Das könnte dir auch gefallen';
    if (l.indexOf('en') === 0) return 'You may also like';
    if (l.indexOf('pt') === 0) return 'Também pode gostar';
    return 'Quizá también te interese';
  }

  function addLabel() {
    var l = lang();
    if (l.indexOf('fr') === 0) return '+ Ajouter';
    if (l.indexOf('de') === 0) return '+ Hinzufügen';
    if (l.indexOf('en') === 0) return '+ Add';
    if (l.indexOf('pt') === 0) return '+ Adicionar';
    return '+ Añadir';
  }

  function cartTitle() {
    var l = lang();
    if (l.indexOf('fr') === 0) return 'Panier';
    if (l.indexOf('de') === 0) return 'Warenkorb';
    if (l.indexOf('en') === 0) return 'Cart';
    if (l.indexOf('pt') === 0) return 'Carrinho';
    return 'Carrito';
  }

  function discountWord() {
    var l = lang();
    if (l.indexOf('fr') === 0) return 'Réduction';
    if (l.indexOf('de') === 0) return 'Rabatt';
    if (l.indexOf('en') === 0) return 'Discount';
    if (l.indexOf('pt') === 0) return 'Desconto';
    return 'Descuento';
  }

  function localePrefix() {
    var l = lang();
    if (l.indexOf('en') === 0) return '/en';
    if (l.indexOf('fr') === 0) return '/fr';
    if (l.indexOf('de') === 0) return '/de';
    if (l.indexOf('pt') === 0) return '/pt-pt';
    return '';
  }

  function ariaMap() {
    var l = lang();
    if (l.indexOf('fr') === 0) {
      return {
        'Close cart': 'Fermer le panier',
        'Decrease quantity': 'Diminuer la quantité',
        'Increase quantity': 'Augmenter la quantité',
        'Remove item': 'Retirer l’article',
        Quantity: 'Quantité',
        'Previous products': 'Produits précédents',
        'Next products': 'Produits suivants',
      };
    }
    if (l.indexOf('de') === 0) {
      return {
        'Close cart': 'Warenkorb schließen',
        'Decrease quantity': 'Menge verringern',
        'Increase quantity': 'Menge erhöhen',
        'Remove item': 'Artikel entfernen',
        Quantity: 'Menge',
        'Previous products': 'Vorherige Produkte',
        'Next products': 'Nächste Produkte',
      };
    }
    if (l.indexOf('en') === 0) {
      return {};
    }
    if (l.indexOf('pt') === 0) {
      return {
        'Close cart': 'Fechar carrinho',
        'Decrease quantity': 'Diminuir quantidade',
        'Increase quantity': 'Aumentar quantidade',
        'Remove item': 'Remover artigo',
        Quantity: 'Quantidade',
        'Previous products': 'Produtos anteriores',
        'Next products': 'Produtos seguintes',
      };
    }
    return {
      'Close cart': 'Cerrar carrito',
      'Decrease quantity': 'Reducir cantidad',
      'Increase quantity': 'Aumentar cantidad',
      'Remove item': 'Quitar producto',
      Quantity: 'Cantidad',
      'Previous products': 'Productos anteriores',
      'Next products': 'Productos siguientes',
    };
  }

  function translateTitle(text) {
    if (!text) return text;
    var l = lang();
    if (l.indexOf('es') === 0 || !l) {
      return text
        .replace(/Joanna dress in brown and blue/gi, 'Vestido Joanna en marrón y azul')
        .replace(/Joanna \| Dress in brown and blue/gi, 'Vestido Joanna en marrón y azul')
        .replace(/Joanna \| Orange dress/gi, 'Joanna | Vestido en naranja')
        .replace(/\bLong dress\b/gi, 'Vestido largo')
        .replace(/\bBordeaux Dress\b/gi, 'Vestido burdeos')
        .replace(/Embroidered elegant blouse/gi, 'Blusa elegante bordada')
        .replace(/Long lace dress/gi, 'Vestido largo de encaje');
    }
    var next = text;
    if (l.indexOf('fr') === 0) {
      next = next
        .replace(/Vestido largo/gi, 'Robe longue')
        .replace(/Vestido Corto|Vestido corto/gi, 'Robe courte')
        .replace(/Rojo intenso/gi, 'Rouge intense')
        .replace(/Marrón ciruela/gi, 'Marron prune')
        .replace(/Vestido Joanna en marrón y azul/gi, 'Joanna | Robe marron et bleue')
        .replace(/Joanna dress in brown and blue/gi, 'Joanna | Robe marron et bleue')
        .replace(/Joanna \| Vestido en naranja/gi, 'Joanna | Robe orange')
        .replace(/\bLong dress\b/gi, 'Robe longue')
        .replace(/\bBordeaux Dress\b/gi, 'Robe bordeaux')
        .replace(/Embroidered elegant blouse/gi, 'Chemisier élégant brodé')
        .replace(/Long lace dress/gi, 'Robe longue en dentelle');
    } else if (l.indexOf('de') === 0) {
      next = next
        .replace(/Vestido largo/gi, 'Langes Kleid')
        .replace(/Vestido Corto|Vestido corto/gi, 'Kurzes Kleid')
        .replace(/Rojo intenso/gi, 'Intensives Rot')
        .replace(/Marrón ciruela/gi, 'Pflaumenbraun')
        .replace(/Vestido Joanna en marrón y azul/gi, 'Joanna | Kleid in Braun und Blau')
        .replace(/Joanna dress in brown and blue/gi, 'Joanna | Kleid in Braun und Blau')
        .replace(/Joanna \| Vestido en naranja/gi, 'Joanna | Kleid in Orange')
        .replace(/\bLong dress\b/gi, 'Langes Kleid')
        .replace(/\bBordeaux Dress\b/gi, 'Bordeauxfarbenes Kleid')
        .replace(/Embroidered elegant blouse/gi, 'Elegante bestickte Bluse')
        .replace(/Long lace dress/gi, 'Langes Spitzenkleid');
    } else if (l.indexOf('en') === 0) {
      next = next
        .replace(/Vestido largo/gi, 'Long dress')
        .replace(/Vestido Corto|Vestido corto/gi, 'Short dress')
        .replace(/Rojo intenso/gi, 'Deep red')
        .replace(/Marrón ciruela/gi, 'Plum brown')
        .replace(/Vestido Joanna en marrón y azul/gi, 'Joanna | Dress in brown and blue')
        .replace(/Joanna \| Vestido en naranja/gi, 'Joanna | Orange dress');
    } else if (l.indexOf('pt') === 0) {
      next = next
        .replace(/Vestido largo/gi, 'Vestido comprido')
        .replace(/Vestido Corto|Vestido corto/gi, 'Vestido curto')
        .replace(/Rojo intenso/gi, 'Vermelho intenso')
        .replace(/Marrón ciruela/gi, 'Castanho ameixa')
        .replace(/Vestido Joanna en marrón y azul/gi, 'Joanna | Vestido em castanho e azul')
        .replace(/Joanna dress in brown and blue/gi, 'Joanna | Vestido em castanho e azul')
        .replace(/Joanna \| Vestido en naranja/gi, 'Joanna | Vestido em laranja')
        .replace(/\bLong dress\b/gi, 'Vestido comprido')
        .replace(/\bBordeaux Dress\b/gi, 'Vestido bordô')
        .replace(/Embroidered elegant blouse/gi, 'Blusa elegante bordada')
        .replace(/Long lace dress/gi, 'Vestido comprido com renda');
    }
    return next;
  }

  function translateChromeText(text) {
    if (!text) return text;
    var l = lang();
    var next = text;
    var aria = ariaMap();
    Object.keys(aria).forEach(function (from) {
      if (next === from) next = aria[from];
    });
    next = translateTitle(next);
    if (l.indexOf('es') === 0 || !l) return next;
    next = next
      .replace(/COMPRAR/g, checkoutLabel())
      .replace(/¿Tienes código de descuento\?/g, discountLabel())
      .replace(/\bCarrito\b/g, cartTitle())
      .replace(/\+\s*Añadir/g, addLabel())
      .replace(/\bAñadir\b/g, addLabel().replace(/^\+\s*/, ''))
      .replace(/Quizá también te interese\.*/gi, relatedLabel());
    if (/^\s*Discount\s*$/i.test(next)) next = discountWord();
    return next;
  }

  function isTaxShippingNote(text) {
    var t = (text || '').replace(/\s+/g, ' ').trim();
    if (!t || t.length > 220) return false;
    return (
      /calculados en la pantalla de pago/i.test(t) ||
      /calculated at checkout/i.test(t) ||
      /calcul[eé]s [àa] l[’'][eé]tape du paiement/i.test(t) ||
      /werden (an der Kasse|beim Bezahlen) berechnet/i.test(t) ||
      /calculado na finaliza/i.test(t) ||
      /portes s[aã]o calculados/i.test(t)
    );
  }

  function fixSubtotalNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.childElementCount === 0) {
      var text = (node.textContent || '').trim();
      if (FROM.test(text)) {
        node.textContent = TO;
        return;
      }
    }
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    var current;
    while ((current = walker.nextNode())) {
      if (FROM.test(current.nodeValue || '')) {
        current.nodeValue = TO;
      }
    }
  }

  function fixTaxNoteNode(node) {
    if (!node || node.nodeType !== 1) return;
    if (!isTaxShippingNote(node.textContent || '')) return;
    if (node.querySelector('input, button, textarea, select')) return;
    for (var i = 0; i < node.children.length; i++) {
      if (isTaxShippingNote(node.children[i].textContent || '')) return;
    }
    node.textContent = freeShippingLabel();
  }

  function fixAttributes(node) {
    if (!node || node.nodeType !== 1 || !node.getAttribute) return;
    ['aria-label', 'title', 'placeholder', 'alt'].forEach(function (attr) {
      var value = node.getAttribute(attr);
      if (!value) return;
      var next = translateChromeText(value);
      if (next !== value) node.setAttribute(attr, next);
    });
  }

  function fixChrome(node) {
    if (!node) return;
    if (node.nodeType !== 1 && node.nodeType !== 11) return;
    if (node.nodeType === 1) fixAttributes(node);
    var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
    var current;
    while ((current = walker.nextNode())) {
      var value = current.nodeValue || '';
      var next = translateChromeText(value);
      if (next !== value) current.nodeValue = next;
    }
    var els = node.querySelectorAll ? node.querySelectorAll('*') : [];
    for (var i = 0; i < els.length; i++) fixAttributes(els[i]);
  }

  function queryAll(doc, selector) {
    try {
      return doc.querySelectorAll(selector);
    } catch (e) {
      return [];
    }
  }

  function fixCheckoutLinks(doc) {
    var prefix = localePrefix();
    if (!prefix) return;
    queryAll(doc, 'a[href]').forEach(function (a) {
      try {
        var u = new URL(a.href, location.origin);
        if (u.origin !== location.origin) return;
        if (u.pathname !== '/checkout' && u.pathname !== '/checkout/') return;
        a.setAttribute('href', prefix + '/checkout' + u.search + u.hash);
      } catch (e) {}
    });
  }

  function fixRoot(doc) {
    if (!doc) return;
    var host = doc.body || doc.documentElement || doc;
    fixChrome(host);
    fixCheckoutLinks(doc);
    queryAll(
      doc,
      '.upcart-footer, .upcart-cart-summary, .upcart-subtotal, .tax-note, [class*="subtotal"], [class*="Subtotal"], [class*="footer"], [class*="upcart"], [id*="upcart"]'
    ).forEach(function (el) {
      fixSubtotalNode(el);
      fixTaxNoteNode(el);
      fixChrome(el);
    });
    queryAll(doc, 'span, p, small, label, div, button, a, h1, h2, h3').forEach(function (el) {
      if (el.childElementCount === 0 && FROM.test(el.textContent || '')) {
        el.textContent = TO;
      }
    });
  }

  function fixAll() {
    roots().forEach(function (doc) {
      try {
        fixRoot(doc);
      } catch (e) {}
    });
  }

  function startObserver() {
    roots().forEach(function (doc) {
      var target = doc.body || doc.documentElement || doc;
      if (!target || typeof MutationObserver === 'undefined') return;
      try {
        var observer = new MutationObserver(function () {
          fixAll();
        });
        observer.observe(target, { childList: true, subtree: true, characterData: true });
      } catch (e) {}
    });
    fixAll();
  }

  function boot() {
    startObserver();
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      fixAll();
      if (tries >= 40) clearInterval(timer);
    }, 500);

    if (typeof window.upcartSubscribeCartLoaded === 'function') {
      window.upcartSubscribeCartLoaded(function () {
        fixAll();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
